import DefaultList from "@/components/DefaultList";
import AgreementCompanyEditor from "@/modules/agreement-companies/components/AgreementCompanyEditor";
import { PATH_DICTS_AGREEMENT_COMPANIES } from "@/constants";
import { createDictionaryLabels } from "@/containers/dictionaries/createDictionaryLabels";
import { defaultDictionaryTableFeatures } from "@/containers/dictionaries/defaultDictionaryTableFeatures";
import { Module } from "@/constants";
import { getDictionaryLabels } from "@/containers/dictionaries/getDictionaryLabels";
import { DictionaryConfig } from "@/containers/dictionaries/types";
import {
  agreementCompanyRead,
  agreementCompanyCreate,
} from "@/schemas/agreementCompany";
import { AgreementCompanyService } from "@/services/agreementCompany";
import {
  AgreementCompany,
  AgreementCompanyCreate,
} from "@/types/agreementCompany";
import { Building2 } from "lucide-react";
import AgreementCompanyCreator from "@/modules/agreement-companies/components/AgreementCompanyCreator";

const id = Module.AgreementCompanies;
const path = PATH_DICTS_AGREEMENT_COMPANIES;
const ns = "agreementCompanies";

const config: DictionaryConfig<AgreementCompany, AgreementCompanyCreate> = {
  id,
  ns,
  service: AgreementCompanyService,
  path,
  labels: createDictionaryLabels(ns),
  getLabels: getDictionaryLabels,
  schema: agreementCompanyCreate,
  defaultValues: { name: "", full_name: "", description: "" },
  excludeFromDefaultMenu: true,
  Icon: Building2,
  List: () => (
    <DefaultList<AgreementCompany>
      schema={agreementCompanyRead}
      name={ns}
      fetchList={AgreementCompanyService.getList}
      pathBuilder={(row) => `${path}/${row.id}`}
      tableFeatures={{
        ...defaultDictionaryTableFeatures,
        exportSettings: { moduleName: Module.AgreementCompanies },
      }}
    />
  ),
  Creator: AgreementCompanyCreator,
  Editor: AgreementCompanyEditor,
};

export default config;
